// Rol del usuario en la plataforma, tal como lo devuelve el backend al
// iniciar sesión y en user/company_info/ (pdui_api/permissions.py):
//   viewer   -> solo mira
//   operator -> además enciende, apaga y reinicia salidas, pide diagnósticos
//   admin    -> además reinicia el equipo, configura, red, firmware, empresa y roles
// El backend es quien manda (devuelve 403); aquí solo se ocultan o
// deshabilitan controles para que la pantalla no prometa lo que no se puede.

const LEVEL = { viewer: 0, operator: 1, admin: 2 };
const KEY = "role";

export function getRole() {
  try {
    const role = window.localStorage.getItem(KEY);
    return role in LEVEL ? role : "operator";
  } catch (e) {
    return "operator";
  }
}

export function setRole(role) {
  try {
    if (role in LEVEL) window.localStorage.setItem(KEY, role);
  } catch (e) {
    // sin storage se asume operador
  }
}

export function hasRole(minimum) {
  return (LEVEL[getRole()] ?? 1) >= (LEVEL[minimum] ?? 0);
}

export const canOperate = () => hasRole("operator");
export const isAdmin = () => hasRole("admin");
export const ROLES = Object.keys(LEVEL);
